// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchLoadCustomers,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const XngPopulateApiParameter: any = (props: any) => {
    props.apiParameter.expand = [...(props.apiParameter.expand || []), "cartLines", "paymentOptions"];
};

// XNG-Changes RUG-590: Checkout - Step 1 - Delivery - Reflect "selected" to select button when the user has one Bill To
export const XngDispatchLoadCustomers: any = (props: any) => {
    if (props.apiResult.billTo) {
        delete props.apiResult.billTo.accountsReceivable;
        delete props.apiResult.billTo.costCodes;
        props.dispatch({
            type: "Data/BillTos/CompleteLoadBillTo",
            model: props.apiResult.billTo,
            isCurrent: getCurrentPage(props.getState()).type === "CheckoutShippingPage",
        });
    }
    if (props.apiResult.shipTo) {
        props.dispatch({
            type: "Data/ShipTos/CompleteLoadShipTo",
            model: props.apiResult.shipTo,
        });
    }
};

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, DispatchLoadCustomers, XngDispatchLoadCustomers);
